/* eslint-disable no-loop-func */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable camelcase */
import { some } from '../../constants';
import { PaginationFilterCustom } from '../../models/pagination';

export interface BookInfo {
  adultCount: number;
  childCount: number;
  time: string;
  date: string;
}
export const defaultBookInfo: BookInfo = {
  adultCount: 1,
  childCount: 0,
  time: '',
  date: '',
};

export interface LocationOption {
  name: string;
  id: number;
}

export interface Restaurant {
  id: string;
  name: string;
  description: string;
  location: string;
  recommend: string;
  cuisine: string;
  present_image?: string;
  favorite_dishes: string;
  short_desc?: string;
  loading?: boolean;
}

export interface DetailRestaurant {
  id: number;
  name: string;
  desc: string;
  map?: string;
  galleries?: Array<string>;
  price?: number;
  average_price?: number;
  location?: string;
  address?: string;
  cuisine?: string;
  about?: string;
  buzz?: string;
  recommend?: string;
  time_sessions?: some;
  session_minute?: number;
  good?: string;
  favorite_dishes?: string;
  menus?: some[];
  images?: some[] | undefined;
  short_desc?: string;
  present_image?: string;
  currency?: string;
}

export function ChangeToSlug(title: string, id: string | number): string {
  let slug = title.toLowerCase();
  slug = slug.replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, 'a');
  slug = slug.replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, 'e');
  slug = slug.replace(/i|í|ì|ỉ|ĩ|ị/gi, 'i');
  slug = slug.replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, 'o');
  slug = slug.replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, 'u');
  slug = slug.replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, 'y');
  slug = slug.replace(/đ/gi, 'd');
  slug = slug.replace(
    // eslint-disable-next-line no-useless-escape
    /\`|\~|\!|\@|\#|\||\$|\%|\^|\&|\*|\(|\)|\+|\=|\,|\.|\/|\?|\>|\<|\'|\"|\:|\;|_/gi,
    '',
  );
  slug = slug.replace(/ /gi, '-');
  // eslint-disable-next-line no-useless-escape
  slug = slug.replace(/\-\-\-\-\-/gi, '-');
  // eslint-disable-next-line no-useless-escape
  slug = slug.replace(/\-\-\-\-/gi, '-');
  // eslint-disable-next-line no-useless-escape
  slug = slug.replace(/\-\-\-/gi, '-');
  // eslint-disable-next-line no-useless-escape
  slug = slug.replace(/\-\-/gi, '-');
  slug = `@${slug}@`;
  // eslint-disable-next-line no-useless-escape
  slug = slug.replace(/\@\-|\-\@|\@/gi, '');
  return `${slug}-${id}`;
}

export interface RestaurantListFilter extends PaginationFilterCustom {
  sortBy?: string;
  sortDir?: string;
  city_code?: string;
  district_code?: string;
  term?: string;
  location?: string;
  cuisine_ids?: string;
  enable_geo: boolean;
  latitude: number | undefined;
  longitude: number | undefined;
  distance_km: number;
  city_id: number | string;
  order_by: number;
}

export const defaultRestaurantListFilter: RestaurantListFilter = {
  sortBy: 'id',
  sortDir: 'desc',
  city_code: '',
  district_code: '',
  location: '',
  term: '',
  cuisine_ids: '',
  enable_geo: true,
  latitude: undefined,
  longitude: undefined,
  distance_km: 10,
  order_by: 3,
  city_id: '',
  page: 0,
  size: 10,
};

export interface BookingInformation {
  email: string;
  firstName: string;
  lastName: string;
  gender: number;
  phone: string;
  reservationTime: string;
  restaurantId?: number;
  partnerCode: string;
  message: string;
  adults: number;
  children: number;
  time: string;
  date: string;
}

export const defaultBookingInformation: BookingInformation = {
  email: '',
  firstName: '',
  lastName: '',
  gender: 0,
  phone: '',
  reservationTime: '',
  restaurantId: 0,
  partnerCode: '',
  message: '',
  adults: 1,
  children: 0,
  time: '',
  date: '',
};

function checkTime(item: some, total: some[]): boolean {
  let check = false;
  total.forEach((i) => {
    if (i.start_time === item.start_time && i.end_time === item.end_time) {
      check = true;
    }
  });
  return check;
}
export function groupByHours(objectArray: some): some {
  let total: any[] = [];
  const days: any[] = [];
  for (const property in objectArray) {
    objectArray[property].forEach(
      (item: { [x: string]: any; start_time?: any; end_time?: any; day?: any }) => {
        if (!total.length) {
          total = [{ ...item, days: [item.day] }];
        } else if (checkTime(item, total)) {
          total = total.map((t) => {
            if (t.start_time === item.start_time && t.end_time === item.end_time) {
              days.push(item.day);
              return { ...t, days: [...days] };
            }
            return { ...t };
          });
        } else {
          total = [...total, { ...item, days: [item.day] }];
        }
      },
    );
  }
  return total;
}

function checkKey(item: string, total: any[]) {
  let check = true;
  total.forEach((j) => {
    if (j.text.trim() === item.trim()) {
      check = false;
    }
  });
  return check;
}
function convertText(list: any[]) {
  let text = '';
  list.map((timeItem) => {
    return (text += `${timeItem.start_time}-${timeItem.end_time} `);
  });
  return text;
}
export function groupByDay(objectArray: { [x: string]: any[] }) {
  let days: any[] = [];
  for (const property in objectArray) {
    if (!days.length) {
      let text = '';
      const range = objectArray[property];
      objectArray[property].map((timeItem) => {
        return (text += `${timeItem.start_time}-${timeItem.end_time} `);
      });
      days = [{ range, text, dates: [property] }];
    } else if (!checkKey(convertText(objectArray[property]), days)) {
      days = days.map((item) => {
        return convertText(objectArray[property]) === item.text
          ? { ...item, dates: [...item.dates, property] }
          : { ...item };
      });
    } else {
      days = [
        ...days,
        {
          range: objectArray[property],
          dates: [property],
          text: convertText(objectArray[property]),
        },
      ];
    }
  }
  return days;
}
